<template>
  <!-- 如何偿还 -->
  <div class="container">
    <!-- 顶部导航栏 -->
    <HeadTab :typeindex="2"></HeadTab>
    <img class="opl" src="/static/img/Mask_group.png" alt="" />
    <div class="obtain">
      <div class="tutorial_inner">
        <div class="tutorial_left">
          <div class="tutorial_title">Как погасить микрокредит?</div>
          <div class="tutorial_card">
            <div class="tutorial_card-title">PAYMENT PROCESS DESCRIPTION</div>
            <div class="tutorial_item">
              <div class="tutorial_num">1</div>
              <div class="tutorial_text">Пользователи отдают приоритет использованию банковских карт для оплаты и совершения операции через онлайн-платёжную платформу.</div>
            </div>
            <div class="tutorial_item">
              <div class="tutorial_num">2</div>
              <div class="tutorial_text">Поддержка оплаты картами VISA и MasterCard.</div>
            </div>
            <div class="tutorial_item">
              <div class="tutorial_num">3</div>
              <div class="tutorial_content">
                <div class="tutorial_text tutorial_text-strong">Процесс работы:</div>
                <div class="tutorial_bullet">Пользователи отдают приоритет использованию банковских карт для оплаты и совершения операции через онлайн-платёжную платформу.</div>
                <div class="tutorial_bullet">Выберите сумму займа и дату погашения, а затем нажмите «Оплатить».</div>
                <div class="tutorial_bullet">На странице ввода данных банковской карты необходимо ввести номер карты, имя владельца карты, срок действия карты и трехзначный код безопасности. Все данные, которые написаны на карте.</div>
                <div class="tutorial_bullet">Далее банк отправит вам текстовое сообщение для подтверждения. Если вы получите и введете правильный код подтверждения, вы перейдете к следующему шагу и завершите платеж.</div>
              </div>
            </div>
            <div class="tutorial_item tutorial_item-last">
              <div class="tutorial_num">4</div>
              <div class="tutorial_text">Если у вас возникнут проблемы при оплате, вы можете связаться с нами по адресу <span>info@kzcredit.kz</span></div>
            </div>
          </div>
        </div>
        <div class="tutorial_right">
          <LoanCard></LoanCard>
        </div>
      </div>
    </div>
    <!-- 底部 -->
    <BomTab :jumpindex="0"></BomTab>
  </div>
</template>

<script>
  import HeadTab from '@/components/HeadTab.vue'
  import BomTab from '@/components/BomTab.vue'
  import LoanCard from '@/components/loancard.vue'
  export default {
    name: "tutorial",
    data() {
      return {

      };
    },
    components: {
      BomTab,
      HeadTab,
      LoanCard
    },
    mounted () {
    },
    methods: {},
  };
</script>

<style scoped>
  .opl{
    width: 3.29rem;
    height: 1.82rem;
    position: absolute;
    top: 0.57rem;
    left: 0;
  }
  .obtain {
    background: rgba(244, 247, 250, 1);
    padding: 0.78rem 1.58rem 1.29rem;
  }
  .tutorial_inner {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 0.58rem;
  }
  .tutorial_left {
    width: 3.48rem;
  }
  .tutorial_title {
    color: rgba(51, 51, 51, 1);
    font-family: Montserrat;
    font-weight: 700;
    font-size: 0.21rem;
    margin-bottom: 0.17rem;
  }
  .tutorial_card {
    border-radius: 0.08rem;
    background: rgba(255, 255, 255, 1);
    padding: 0.13rem;
  }
  .tutorial_card-title {
    color: rgba(0, 102, 204, 1);
    font-family: Montserrat;
    font-weight: 700;
    font-size: 0.1rem;
    text-transform: uppercase;
    margin-bottom: 0.15rem;
  }
  .tutorial_item {
    display: flex;
    align-items: flex-start;
    margin-bottom: 0.08rem;
  }
  .tutorial_item-last {
    margin-bottom: 0;
  }
  .tutorial_num {
    width: 0.16rem;
    height: 0.16rem;
    line-height: 0.16rem;
    border-radius: 50%;
    background: rgba(0, 102, 204, 0.1);
    color: rgba(0, 102, 204, 1);
    font-family: "SF Pro Text";
    font-weight: 700;
    font-size: 0.08rem;
    text-align: center;
    margin-right: 0.05rem;
    flex-shrink: 0;
  }
  .tutorial_content {
    flex: 1;
  }
  .tutorial_text {
    color: rgba(102, 102, 102, 1);
    font-family: Montserrat;
    font-weight: 500;
    font-size: 0.08rem;
    line-height: 0.13rem;
  }
  .tutorial_text-strong {
    color: rgba(51, 51, 51, 1);
    font-family: Montserrat;
    font-weight: 700;
    font-size: 0.08rem;
    margin-bottom: 0.06rem;
  }
  .tutorial_text span {
    color: rgba(0, 102, 204, 1);
  }
  .tutorial_bullet {
    position: relative;
    padding-left: 0.1rem;
    margin-bottom: 0.1rem;
    color: rgba(102, 102, 102, 1);
    font-family: Montserrat;
    font-weight: 400;
    font-size: 0.09rem;
    line-height: 0.14rem;
  }
  .tutorial_bullet::before {
    content: '';
    width: 0.03rem;
    height: 0.03rem;
    border-radius: 50%;
    background: rgba(0, 102, 204, 1);
    position: absolute;
    top: 0.06rem;
    left: 0;
  }
  .tutorial_bullet:last-child {
    margin-bottom: 0;
  }
  .tutorial_right {
    width: 2.78rem;
  }

  @media screen and (max-width: 1200px) {
    .obtain {
      padding-left: 0.4rem;
      padding-right: 0.4rem;
    }
    .tutorial_inner {
      gap: 0.24rem;
    }
    .tutorial_left,
    .tutorial_right {
      width: 50%;
    }
  }

  @media screen and (max-width: 768px) {
    .opl{
      width: 2.29rem;
      height: 1.32rem;
      position: absolute;
      top: 0.95rem;
      left: 0;
    }
    .obtain {
      padding-top: 0.42rem;
      padding-bottom: 0.48rem;
    }
    .tutorial_inner {
      flex-direction: column;
    }
    .tutorial_left,
    .tutorial_right {
      width: 100%;
    }
    .tutorial_title {
      font-size: 0.24rem;
      line-height: 0.3rem;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/tutorial.vue